module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c43622e69ed5cf70575aba04b2c90b9a.png";